import React, { useEffect, useState, useRef } from 'react';
import './SearchedLocation.scss';
import mapboxgl from 'mapbox-gl';
import Spinner from '../../Spinner';
import { DataGrid } from '@mui/x-data-grid';
import RiskComponent from '../../RiskComponent';
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function SearchedLocation(props) {
    const {
        panel,
        setPanel,
        user,
        map
    } = props;

    const FireHistoryTable = RiskComponent.FireHistoryTable;

    const [stage, setStage] = useState('Fire Risk');
    const locationRef = useRef(null);

    useEffect(() => {
       if (panel.content && panel.content.coordinates) {
        const point = document.createElement('div');
        point.className = 'map-pin-marker';
        const marker = new mapboxgl.Marker(point)
            .setLngLat(panel.content.coordinates)
            .addTo(map.current);

        locationRef.current = marker;

        return () => {
            if (locationRef.current) {
                locationRef.current.remove();
            }
        }
       }
    }, [panel.content]);

    useEffect(() => {
        setStage('Fire Risk');
    }, [panel]);

    const stageSwitch = (stage) => {
        switch (stage) {
            case 'Fire Risk':
                return (
                    <RiskComponent 
                        user={user}
                        coordinates={panel?.content?.coordinates}
                    />
                )
            case 'Fire History':
                return (
                   <div style={{ width: '100%', overflowY: 'scroll', height: '67%' }}>
                     <FireHistoryTable />
                   </div>
                )
        }
    }

    return (
        <div className='searched-location-page'>
            <div className='searched-location-page-title'>
                {/* <MagnifyingGlass size={24} className='searched-location-page-title-icon'/> */}
                <div className='searched-location-page-title-text'>Searched Location</div>
            </div>
            <div className='searched-location-page-description'>Search for a specific location and retrieve data on fire risks, danger levels, and historical fire incidents, and more</div>
            <div className='searched-location-page-address'>{panel?.content?.address}</div>
            <div className='searched-location-page-tabs'>
                    {['Fire Risk', 'Fire History'].map((t, index) => (
                        <div
                            key={index}
                            className='searched-location-page-tabs-tab'
                            style={{
                                borderBottom: t === stage ? '2px solid #0080ff' : ''
                            }}
                            onClick={() => setStage(t)}
                        >
                           {t}
                        </div>
                    ))}
            </div>
            {stageSwitch(stage)}
        </div>
    )
}